// Ленивые чанки после деплоя. Вкладка, открытая до выкатки, продолжает
// ссылаться на старые имена файлов (`load-dashboard-panel-Ca16PhM_.js`), и
// первое же открытие такой панели падает с «Failed to fetch dynamically
// imported module» — для саппорта это «клиент вылетел». Ассеты уже другие,
// починить в рантайме нечего: единственный корректный выход — перезагрузить
// вкладку, причём ровно один раз, иначе при настоящей потере сети получим
// петлю перезагрузок.

const RELOAD_FLAG = "tg:chunk-reload-at";
const RELOAD_COOLDOWN_MS = 60_000;

const isStaleChunkError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Importing a module script failed")
  );
};

const reloadOnce = (): boolean => {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_FLAG) ?? "0");
    if (Number.isFinite(last) && Date.now() - last < RELOAD_COOLDOWN_MS) {
      return false;
    }
    window.sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  } catch {
    // Приватный режим / заблокированное хранилище: одна перезагрузка всё
    // равно лучше, чем неработающая панель.
  }
  window.location.reload();
  return true;
};

// Оборачивает фабрику динамического импорта для React.lazy:
// lazy(withChunkRefresh(() => import("./panel.js"))).
export const withChunkRefresh =
  <TModule,>(factory: () => Promise<TModule>): (() => Promise<TModule>) =>
  () =>
    factory().catch((cause: unknown): Promise<TModule> => {
      if (isStaleChunkError(cause) && reloadOnce()) {
        // Возвращаем «вечный» промис: страница уже перезагружается, рисовать
        // ошибку и мигать боундари незачем.
        return new Promise<TModule>(() => {});
      }
      throw cause;
    });
